import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import { Container, Dimmer, Loader } from "semantic-ui-react";
import MenuIcon from "@material-ui/icons/Menu";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SwapVertIcon from "@material-ui/icons/SwapVert";
import "./Home.scss";
import api from "../../api";
import { Role } from "../../enums/enums";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import ListItemText from "@material-ui/core/ListItemText";
import ArrowIcon from "@material-ui/icons/ArrowBack";
import { useNavigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AuthTypes } from "../../redux/actions/_types";

export default function Home({ setDataToast }) {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { decoded } = useSelector((state) => state.authReducer);

  const [userData, setUserData] = useState({
    username: "",
    role: "",
    roleName: "",
    companies: [],
  });
  const [companyName, setCompanyName] = useState();
  const [selectedCompany, setSelectedCompany] = useState();
  const [anchor, setAnchor] = useState();
  const [openJob, setOpenjob] = useState();
  const [openAgreements, setOpenAgreements] = useState();
  const [openSalesChannel, setOpenSalesChannel] = useState();
  const [openSales, setOpenSales] = useState();
  const [loadingActive, setLoadingActive] = useState();
  const [companyDialog, setCompanyDialog] = useState(false);

  const openJobClick = () => {
    setOpenjob(!openJob);
  };

  const openAgreementsClick = () => {
    setOpenAgreements(!openAgreements);
  };

  const openSalesChannelClick = () => {
    setOpenSalesChannel(!openSalesChannel);
  };

  const openSalesClick = () => {
    setOpenSales(!openSales);
  };

  function logout() {
    dispatch({
      type: AuthTypes.LOGOUT,
    });
    window.localStorage.removeItem("expirationTokenLog");
    window.localStorage.removeItem("tokenLog");
    navigate(0);
  }

  function checkRole(role) {
    let response = false;

    role.forEach((i) => {
      if (i === userData.role || i === Role.All) response = true;
    });

    return response;
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setAnchor(open);
  };

  function refreshToken(companyId) {
    setCompanyName(userData.companies.find((e) => e.Id === companyId).Name);
    setSelectedCompany(parseInt(companyId));
    setLoadingActive(true);
    api
      .refreshToken(companyId)
      .then((res) => {
        localStorage.removeItem("tokenLog");
        api.setHeaderAuthorization(res.data.token);
        setLoadingActive(false);
      })
      .catch((err) => {
        setLoadingActive(false);
        setDataToast({
          active: true,
          type: "error",
          message: "Ocurrió un error.",
        });
      });
    setCompanyDialog(false);
  }

  useEffect(() => {
    let companyId = parseInt(decoded.primarygroupsid);
    let companies = undefined;
    let role = decoded.role;
    if (decoded.companies) {
      companies = JSON.parse(decoded.companies);
      setCompanyName(companies.find((e) => e.Id === companyId).Name);
    }
    setSelectedCompany(companyId);

    let roleName = "";
    switch (role) {
      case Role.AdminComercial:
        roleName = "Admin Comercial";
        break;
      case Role.InternalSeller:
        roleName = "Vendedor Interno";
        break;
      case Role.ExternalSeller:
        roleName = "Vendedor Externo";
        break;
      default:
        break;
    }

    setUserData({
      username: decoded.username,
      role: role,
      roleName: roleName,
      companies: companies,
    });

    window.localStorage.removeItem("isLogged");
  }, []);

  const CustomListItem = ({ Text, Link }) => (
    <ListItem className="c-list-item" button onClick={() => navigate(Link)}>
      {Text}
    </ListItem>
  );

  return (
    <>
      {loadingActive ? (
        <Dimmer active inverted>
          <Loader size="big">Cargando..</Loader>
        </Dimmer>
      ) : (
        <>
          <AppBar className="c-appbar" position="static">
            <Toolbar className="c-m-n-5">
              <div className="c-appbar-left">
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={toggleDrawer(true)}
                >
                  <MenuIcon />
                </IconButton>
              </div>

              <div className="c-appbar-right c-text-with-icon">
                {userData.role !== Role.AdminComercial &&
                  userData.role !== Role.AdminIT && (
                    <div className="c-items">
                      <IconButton
                        className="c-change-company-btn"
                        edge="start"
                        color="inherit"
                        onClick={() => setCompanyDialog(!companyDialog)}
                      >
                        {companyName}
                        <SwapVertIcon className="c-icon-primary" />
                      </IconButton>

                      <Dialog
                        className="c-company-dialog"
                        onClose={() => setCompanyDialog(!companyDialog)}
                        open={companyDialog}
                      >
                        <DialogTitle>Seleccionar compañia</DialogTitle>
                        <List>
                          {userData?.companies?.map((x) => (
                            <ListItem
                              className="c-company-dialog-item"
                              autoFocus
                              button
                              key={x.Id}
                              disabled={x.Id === selectedCompany ?? false}
                              onClick={() => refreshToken(x.Id)}
                            >
                              {x.Name}
                            </ListItem>
                          ))}
                        </List>
                      </Dialog>
                    </div>
                  )}

                <div className="c-items c-ml-10">
                  <div className="c-text-with-icon">
                    <h4 className="c-mb-0 c-username">
                      {userData.username}
                      <p>{userData.roleName}</p>
                    </h4>
                    <ExitToAppIcon
                      className="c-ml-5 c-logout-icon"
                      onClick={logout}
                      titleAccess="Cerrar sesión"
                    />
                  </div>
                </div>
              </div>
            </Toolbar>
          </AppBar>

          <Drawer
            className="c-left-menu"
            anchor="left"
            open={anchor}
            onClose={toggleDrawer(false)}
          >
            <div role="presentation" onKeyDown={toggleDrawer(false)}>
              <List className="c-list">
                <div onClick={toggleDrawer(false)}>
                  <CustomListItem Text="Inicio" Link="/inicio" />
                </div>
                {checkRole([
                  Role.InternalSeller,
                  Role.ExternalSeller,
                  Role.AdminComercial,
                ]) && (
                  <ListItem
                    button
                    onClick={openAgreementsClick}
                    className="c-list-item"
                  >
                    <div className="c-div-text">Contratos</div>
                    <ListItemText className="c-div-text" />
                    {openAgreements ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                )}
                {checkRole([
                  Role.InternalSeller,
                  Role.ExternalSeller,
                  Role.AdminComercial,
                ]) && (
                  <Collapse in={openAgreements} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <div onClick={toggleDrawer(false)}>
                        <CustomListItem
                          Text=" > Gestión"
                          Link="/contrato"
                          IconMenuButton={<ArrowIcon className="c-item-icon" />}
                        />
                        <CustomListItem
                          Text=" > Creación Masiva"
                          Link="/contrato/creacion-masiva"
                          IconMenuButton={<ArrowIcon className="c-item-icon" />}
                        />
                      </div>
                    </List>
                  </Collapse>
                )}
                {checkRole([Role.AdminComercial]) && (
                  <div onClick={toggleDrawer(false)}>
                    <CustomListItem Text="Producto" Link="/producto" />
                  </div>
                )}
                {checkRole([Role.AdminComercial]) && (
                  <div onClick={toggleDrawer(false)}>
                    <CustomListItem
                      Text="Tipo Asistencia"
                      Link="/tipos-asistencias"
                    />
                  </div>
                )}
                {checkRole([Role.AdminComercial]) && (
                  <ListItem
                    button
                    onClick={openJobClick}
                    className="c-list-item"
                  >
                    <div className="c-div-text">Medios de Pago</div>
                    <ListItemText className="c-div-text" />
                    {openJob ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                )}
                {checkRole([Role.AdminComercial]) && (
                  <Collapse in={openJob} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <div onClick={toggleDrawer(false)}>
                        <CustomListItem
                          Text=" > Listado"
                          Link="/medios-pago"
                          IconMenuButton={<ArrowIcon className="c-item-icon" />}
                        />
                        <CustomListItem
                          Text=" > Asignar a Compañía"
                          Link="/medio-de-pago/asignar"
                          IconMenuButton={<ArrowIcon className="c-item-icon" />}
                        />
                      </div>
                    </List>
                  </Collapse>
                )}
                {checkRole([Role.AdminComercial]) && (
                  <div onClick={toggleDrawer(false)}>
                    <CustomListItem Text="Categoría" Link="/categoria" />
                  </div>
                )}
                {checkRole([Role.AdminComercial, Role.AdminIT]) && (
                  <div onClick={toggleDrawer(false)}>
                    <CustomListItem Text="Usuarios" Link="/usuario" />
                  </div>
                )}
                {checkRole([Role.AdminComercial]) && (
                  <ListItem
                    button
                    onClick={openSalesChannelClick}
                    className="c-list-item"
                  >
                    <div className="c-div-text">Canales de Venta</div>
                    <ListItemText className="c-div-text" />
                    {openSalesChannel ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                )}
                {checkRole([Role.AdminComercial]) && (
                  <Collapse in={openSalesChannel} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <div onClick={toggleDrawer(false)}>
                        <CustomListItem
                          Text=" > Asignación"
                          Link="/canales-venta"
                          IconMenuButton={<ArrowIcon className="c-item-icon" />}
                        />
                        <CustomListItem
                          Text=" > Externos"
                          Link="/canales-venta/externos"
                          IconMenuButton={<ArrowIcon className="c-item-icon" />}
                        />
                      </div>
                    </List>
                  </Collapse>
                )}

                {checkRole([Role.InternalSeller]) && (
                  <ListItem
                    button
                    onClick={openSalesClick}
                    className="c-list-item"
                  >
                    <div className="c-div-text">Ventas</div>
                    <ListItemText className="c-div-text" />
                    {openSales ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                )}
                {checkRole([Role.InternalSeller]) && (
                  <Collapse in={openSales} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <div onClick={toggleDrawer(false)}>
                        <CustomListItem
                          Text=" > Procesar Ventas"
                          Link="/procesar-ventas"
                          IconMenuButton={<ArrowIcon className="c-item-icon" />}
                        />
                      </div>
                    </List>
                  </Collapse>
                )}
                {checkRole([Role.AdminComercial]) && (
                  <div onClick={toggleDrawer(false)}>
                    <CustomListItem Text="Email" Link="/email" />
                  </div>
                )}
              </List>
            </div>
          </Drawer>
          <Container className="c-mt-20 c-mb-20">
            <Outlet />
          </Container>
        </>
      )}
    </>
  );
}
